import React from 'react';
import ReactDOM from 'react-dom/client';
import { requestPersistentStorage } from './lib/persistent-storage.js';
import { installTrustedTypes } from './lib/trusted-types.js';
import { App } from './App.js';
import './index.css';

// Install Trusted Types default policy BEFORE React mounts. React 18
// hydration uses innerHTML on the root, which a strict CSP
// `require-trusted-types-for 'script'` would reject without a default
// policy being present.
installTrustedTypes();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

// Запрашиваем persistent storage чтобы WKWebView не evict'нул IndexedDB через 7 дней.
// Не блокируем рендер — выполняется параллельно.
requestPersistentStorage().then((state) => {
  if (state === 'denied') {
    console.warn('[storage] persist denied — IndexedDB может быть очищен через 7д простоя');
  } else if (state === 'unavailable') {
    console.warn('[storage] persist API недоступен');
  } else {
    console.info('[storage] persistent storage активен');
  }
});

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
